<template>
  <div>
    <v-toast ref="errorToast" />
    <div class="px-10 pb-6">
      <v-row>
        <v-col cols="12">
          <div class="form-container">
            <div class="search-form">
              <v-row no-gutter>
                <v-spacer />
                <v-col cols="5" class="d-flex align-center">
                  <v-text-field
                    class="mr-3"
                    data-testid="order-id-input"
                    label="Order Id"
                    hide-details
                    clearable
                    rounded
                    solo
                    flat
                    v-model="params.orderId"
                  />

                  <v-btn
                    class="ml-3"
                    color="primary"
                    dark
                    data-testid="filter-users-button"
                    @click="fetchUsers"
                    :loading="loading"
                    readonly
                  >
                    <span> Search </span>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="IAP Order">
      <v-simple-table data-testid="all-user-list">
        <thead>
          <tr>
            <th width="1%"></th>
            <th class="text-left">Name</th>
            <th class="text-left">Email</th>
            <th class="text-left">Plan</th>
            <th class="text-right">Joined Date</th>
          </tr>
        </thead>
        <tbody>
          <template>
            <tr
              v-for="user in userList"
              :key="user.id"
              class="clickable new-tab-link-row"
            >
              <td class="py-3">
                <user-avatar class="mx-auto" :avatar="user.avatar" size="36" />

                <router-link
                  :to="{
                    name: 'user.profile',
                    params: { id: user.id },
                  }"
                  class="row-link"
                />
              </td>
              <td>
                {{ user.full_name }}

                <router-link
                  :to="{
                    name: 'user.profile',
                    params: { id: user.id },
                  }"
                  class="row-link"
                />
              </td>
              <td>
                {{ user.email }}

                <router-link
                  :to="{
                    name: 'user.profile',
                    params: { id: user.id },
                  }"
                  class="row-link"
                />
              </td>
              <td>
                <span v-if="user.default_program">
                  {{ user.default_program.name }}
                  {{ user.default_program.package_name }}
                </span>

                <router-link
                  :to="{
                    name: 'user.profile',
                    params: { id: user.id },
                  }"
                  class="row-link"
                />
              </td>
              <td class="text-right">
                <span v-if="user.default_program">
                  {{ user.created_at | formatDate }}
                </span>

                <router-link
                  :to="{
                    name: 'user.profile',
                    params: { id: user.id },
                  }"
                  class="row-link"
                />
              </td>
            </tr>
          </template>
        </tbody>
        <table-skeleton-loader v-if="loading" column="5" row />
      </v-simple-table>
      <no-list
        v-if="!userList.length && !loading"
        details="No Available Users"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import NoList from '@/components/elements/NoList'
import UserAvatar from '@/components/UserAvatar'
import TableSkeletonLoader from '@/components/elements/loaders/TableSkeleton'
import VToast from '@/components/elements/Toast'

export default {
  name: 'IAPOrders',

  components: {
    NoList,
    UserAvatar,
    TableSkeletonLoader,
    VToast,
  },

  data() {
    return {
      loading: false,
      params: {
        orderId: '',
      },
      userList: [],
    }
  },

  created() {
    this.setFilter({
      ...this.filter,
      type: 'iap_orders',
    })
  },

  methods: {
    ...mapMutations({
      setFilter: 'users/setFilter',
    }),
    async fetchUsers() {
      const { orderId } = this.params
      if (!orderId) {
        this.$refs.errorToast.open({
          color: 'red',
          message: 'orderId are required',
        })
        return
      }
      if (this.loading) return
      this.userList = []
      this.loading = true
      try {
        const res = await this.$api.get(
          `/users/searchByOrderId?order_id=${orderId}`
        )
        this.userList = res.data.data ? [res.data.data] : []
      } catch (err) {
        this.userList = []
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
